import styled from "@emotion/styled";
const Block = styled.div`
  max-width: 400px;
  min-width: fit-content;
`;
type ErrorComponentProps = {
  error: string[] | string;
};

export const ErrorComponent = ({ error }: ErrorComponentProps) => {
  const render = () => {
    if (typeof error === "string") {
      return error;
    }
    return error.map((msg) => <div key={msg}>{msg}</div>);
  };
  return <Block>{render()}</Block>;
};
